import { Box, PasswordInput, PasswordInputProps, Popover, Progress } from '@mantine/core';
import { useField } from 'formik';
import { useState } from 'react';
import { Checks } from './checks/component';
import { getStrength } from './utils';

interface Props {
	passwordProps: PasswordInputProps;
	reenterPasswordProps: PasswordInputProps;
}

export const PasswordSection = (props: Props) => {
	const [popoverOpened, setPopoverOpened] = useState(false);
	const { passwordProps, reenterPasswordProps } = props;
	const [field] = useField<string>(passwordProps.name ?? 'password');
	const value = field.value;

	const strength = getStrength(value);
	const color = strength === 100 ? 'teal' : strength > 50 ? 'yellow' : 'red';

	return (
		<Popover
			opened={popoverOpened}
			position="bottom"
			width="target"
			transitionProps={{ transition: 'pop' }}
			withArrow
		>
			<Popover.Target>
				<Box
					w="100%"
					onFocusCapture={() => setPopoverOpened(true)}
					onBlurCapture={() => setPopoverOpened(false)}
				>
					<PasswordInput {...passwordProps} />
					<PasswordInput {...reenterPasswordProps} />
				</Box>
			</Popover.Target>
			<Popover.Dropdown>
				<Progress color={color} value={strength} size={5} mb="xs" />
				<Checks value={value} />
			</Popover.Dropdown>
		</Popover>
	);
};
